import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { FiClock } from 'react-icons/fi';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export default function LiveClassCard({ liveClass }) {
  const isSame = moment(liveClass['initial-date']).format('YYYY-MM-DD') === moment(liveClass['end-date']).format('YYYY-MM-DD');
  const formattedInitialDate = moment(liveClass['initial-date']).format(isSame ? 'H[h]' : 'DD/MM - H[h]');
  const formattedEndDate = moment(liveClass['end-date']).format(isSame ? 'H[h]' : 'DD/MM - H[h]');
  const isOnSchedule = moment().isBetween(liveClass['initial-date'], liveClass['end-date']);

  return (
    <div className={cn('flex cursor-default flex-col gap-3 rounded-2xl border border-neutral-lightest p-3 shadow-card transition-shadow duration-150 hover:shadow-card-hover', isOnSchedule ? 'bg-[#FFF5CC]' : 'bg-white')}>
      <Badge
        variant={isOnSchedule ? 'red' : 'muted'}
        className="w-fit rounded-[4px] px-1.5 py-0.5 text-2xs font-extrabold uppercase leading-none tracking-wide"
      >
        Ao vivo
      </Badge>

      <div>
        <h4
          className="mb-0 truncate text-sm font-extrabold text-neutral-900"
          title={liveClass.title}
        >
          {liveClass.title}
        </h4>
        {liveClass.courses?.[0]?.name && <p className="mb-0 truncate text-xs text-neutral-dark">{liveClass.courses[0].name}</p>}
      </div>

      <p className="mb-0 flex items-center gap-1 text-xs font-semibold text-neutral-dark">
        <FiClock className="h-3.5 w-3.5 shrink-0" />
        {formattedInitialDate} às {formattedEndDate}
      </p>

      {isOnSchedule ? (
        <Link
          to={String(liveClass.id)}
          className="mt-1 block w-full rounded-full py-2 text-center text-xs font-extrabold text-white transition-transform duration-100 active:translate-y-px"
          style={{ background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)' }}
        >
          Acessar
        </Link>
      ) : (
        <span className="mt-1 block w-full rounded-full bg-[#ECE9F8] py-2 text-center text-xs font-extrabold text-gray-400">Acessar</span>
      )}
    </div>
  );
}
